module.exports = __webpack_public_path__ + "img/_ABS9846.3dfde166.jpg";